import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig'
import { authHeader } from '../_helpers/auth-header'

export const vaccineGroupService = {
  getAll,
  create,
  reservations,
  reservationsByGroup
};

function reservationsByGroup(id, params = {}) {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/group/${id}/reservations?${queryString.stringify(params)}`,
  }).then(response => response.data);
}

function reservations(params = {}) {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/reservation?${queryString.stringify(params)}`,
  }).then(response => response.data);
}

function create(name, code) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/group`,
    data: { name, code },
  }).then(response => response.data.data);
}

function getAll() {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/group`,
  }).then(response => response.data.data);
}